import {
  WidgetModule,
  WidgetVariantMap,
  Widgets,
  placeholdersMap,
  widgetVariants,
  widgetsMap,
} from './widgets/types.js';
import { findMatchingScriptElement, getWidgetData, createWidgetComponent } from '@scripts/widgets/utils.js';

export async function main(): Promise<void> {
  const currentUrl = new URL(import.meta.url);
  const id = findMatchingScriptElement(currentUrl);
  if (!id) throw new Error('ID must be provided in the URL');

  const widgetData = await getWidgetData(id);

  for (const widget of Object.values(Widgets)) {
    const placeholders = document.querySelectorAll<HTMLElement>(
      `.${placeholdersMap[widget]}-dark, .${placeholdersMap[widget]}-light`,
    );

    if (placeholders.length === 0) continue;

    const widgetModule = (await widgetsMap[widget]()) as WidgetModule;

    for (const placeholder of placeholders) {
      if (!(placeholder instanceof HTMLElement)) continue;
      if (placeholder.childElementCount > 0) continue;

      const isDark = placeholder.classList.contains(`${placeholdersMap[widget]}-dark`);
      const themeClass: keyof WidgetVariantMap = isDark ? 'dark' : 'light';

      const widgetDataForPlaceholder = {
        ...widgetData,
        variant: widgetVariants[widget][themeClass],
      };

      const widgetComponent = await createWidgetComponent(widget, widgetModule, widgetDataForPlaceholder);

      if (!(widgetComponent instanceof HTMLElement)) continue;

      placeholder.appendChild(widgetComponent);
    }
  }
}

main();
